import styled from '@emotion/styled';
import React, {useCallback} from 'react';
import {EIconButton} from 'webapp-lib/Components';

import {Pause, Play} from '_/assets/images';

export const PlayButton = ({
  startTimer,
  stopTimer,
  isRunning,
  disabled = false,
}: {
  startTimer: () => void;
  stopTimer: () => void;
  isRunning: boolean;
  disabled?: boolean;
}): React.ReactElement => {
  const handleClick = useCallback(
    (event: React.MouseEvent, callback: () => void) => {
      event.stopPropagation();
      callback();
    },
    []
  );

  return (
    <StyledPlayButton>
      {!isRunning && (
        <EIconButton
          disabled={disabled}
          title={
            !disabled
              ? 'Tracking starten'
              : 'Zum Starten des Trackings wird ein Titel benötigt.'
          }
          onClick={(evt) => handleClick(evt, startTimer)}
        >
          <Play />
        </EIconButton>
      )}
      {isRunning && (
        <EIconButton
          disabled={disabled}
          title='Tracking stoppen'
          onClick={(evt) => handleClick(evt, stopTimer)}
        >
          <Pause />
        </EIconButton>
      )}
    </StyledPlayButton>
  );
};

const StyledPlayButton = styled.div`
  & .EIconButton {
    padding-left: var(--gutter-medium);
    padding-right: var(--gutter-medium);

    cursor: pointer;

    &:disabled {
      opacity: 0.65;
      cursor: not-allowed;
      pointer-events: all;
    }
  }
`;
